import React from "react";
import { serviceCaller } from "../../../../composition";
import styles from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import { Props } from "./types";
import { Button, Row } from "reactstrap";

const SuccessScreen = ({ source, goBack }: Props) => {
  return (
    <div className={styles.successContainer}>
      <i
        className="fa fa-check-circle"
        style={{ color: "#CDDDE8", fontSize: "10rem", marginBottom: "1rem" }}
        aria-hidden="true"
      ></i>
      <h1 style={{ marginBottom: "10rem" }}>
        {source} Successfully Connected to ViewSpark
      </h1>
      <Row className={styles.actionsContainer}>
        <Button className={styles.button} onClick={goBack}>
          Back
        </Button>
      </Row>
    </div>
  );
};

export default serviceCaller(withStyles(styles)(SuccessScreen));
